import { useMutation } from "@tanstack/react-query";

import {
  createAdhocRunConfig,
  createDryRunPlan,
  deleteAdhocRunConfig,
  deleteIntegrationSettings,
  postIntegrationSettings,
  setIntegrationEnabled,
  stopAdHocRun,
  stopDryTestRun,
  updateAdhocRunConfig,
  updateIntegrationSettings,
  updateManualSteps,
} from "./test-run.api";

export const useCreateAdhocConfig = () => {
  return useMutation({
    mutationFn: (payload: any) => createAdhocRunConfig(payload),
  });
};

export const useUpdateAdhocConfig = (configId: number) => {
  return useMutation({
    mutationFn: (payload: any) => updateAdhocRunConfig(configId, payload),
  });
};

export const useDeleteAdhocConfig = () => {
  return useMutation({
    mutationFn: (configId: number) => deleteAdhocRunConfig(configId),
  });
};

// DRY RUN PLAN
export const useCreateDryRun = () => {
  return useMutation({
    mutationFn: (payload: any) => createDryRunPlan(payload),
  });
};

// Stop dry run
export const useStopDryTestRun = () => {
  return useMutation({
    mutationFn: ({ testPlanResultId, ...payload }: any) =>
      stopDryTestRun(testPlanResultId, payload),
  });
};

// Stop a slim ad-hoc run by test_case_result id
export const useStopAdHocRun = () => {
  return useMutation({
    mutationFn: (testCaseResultId: number | string) =>
      stopAdHocRun(testCaseResultId),
  });
};

export const useSaveIntegrationSettings = () => {
  return useMutation({
    mutationFn: (payload: any) => postIntegrationSettings(payload),
  });
};

export const useUpdateIntegrationSettings = (
  integrationId?: number | string | null,
) => {
  return useMutation({
    mutationFn: (payload: any) =>
      updateIntegrationSettings(payload.id ?? integrationId, payload),
  });
};

export const useSetIntegrationEnabled = () => {
  return useMutation({
    mutationFn: ({
      integrationId,
      enabled,
    }: {
      integrationId: number | string;
      enabled: boolean;
    }) => setIntegrationEnabled(integrationId, enabled),
  });
};

export const useDeleteIntegrationSettings = () => {
  return useMutation({
    mutationFn: (integrationId: number | string) =>
      deleteIntegrationSettings(integrationId),
  });
};

export const useUpdateManualSteps = () => {
  return useMutation({
    mutationFn: async ({
      testStepResultId,
      payload,
    }: {
      testStepResultId: number | string;
      payload: any;
    }) => updateManualSteps(testStepResultId, payload),
  });
};
